'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  clear: 'Clear the map refinement',
  toggle: 'Search as I move the map',
  redo: 'Redo search here'
};


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/widgets/geo-search/defaultTemplates.js